<template>
  <v-container fluid class="px-0">
    <div class="creativeproject-page">
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-card class="folder-card ma-1">
            <v-card-text class="pa-5 pt-0">
              <v-row justify="center" style="margin-top: 5px;">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col md="11">
                      <p class="text-h5">{{ initvalue.projectname }}</p>
                    </v-col>
                    <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="1">
                  <div style="align-content: top;">
                    <v-img
                        v-if="initvalue.projectimage" 
                        v-bind:src="initvalue.projectimage"
                        max-height="80"
                        max-width="80"
                        contain
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Date</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Type</span></td>
                          <td>{{ initvalue.projecttype }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Marketing Rep</span></td>
                          <td>{{  }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Complete By</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1">
                <v-card-text class="pa-5 pt-0">
                  <v-tabs color="primary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-campaigns'"
                    >
                      Campaigns
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-contents'"
                    >
                      <span>Contents</span>
                      <span style="font-size: 8pt;">{{`${campaignid!=null ? '('+contents.filter(content=>content.campaignid==campaignid).length+')' : ''}` }}</span>
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-posts'"
                    >
                      <span>Posts</span>
                      <span style="font-size: 8pt;">{{`${contentid!=null  ? '('+posts.filter(post=>post.contentid==contentid).length+')' : ''}` }}</span>
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="4"
                      :href="'#tab-comments'"
                    >
                    <span>Comments</span>
                    <span style="font-size: 8pt;">{{`${contentid!=null ? '('+comments.filter(comment=>comment.contentid==contentid).length+')' : ''}` }}</span>
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="5"
                      :href="'#tab-ads'"
                    >
                    <span>Ads</span>
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-campaigns'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Campaigns</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="primary"
                                  @click="isAddCampaign=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="campaignstartdate"
                                sort-desc
                                show-select
                                single-select
                                v-model="selectedCampaign"
                                item-key="_id"
                                :headers="header_campaigns"
                                :items="data_campaigns"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                              <template v-slot:top>
                                  <v-dialog v-model="isDeleteCampaign" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Campaign? </v-card-title>
                                      <v-card-text>
                                        {{ delete_campaign.campaignname }}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteCampaign = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectCampaign(delete_campaign)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.campaignimage="{ item }">
                                  <v-img
                                    v-bind:src="item.campaignimage"
                                    max-height="60"
                                    max-width="60"
                                  ></v-img>
                                </template>
                                <template v-slot:item.campaignname="{ item }">
                                  <p class="two-line">{{ item.campaignname }}</p>
                                  <p class="two-line">{{ item.campaigntype }}</p>
                                </template>
                                <template v-slot:item.campaignstartdate="{ item }">
                                  {{ new Date(item.campaignstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                                </template>
                                <template v-slot:item.campaignenddate="{ item }">
                                  {{ new Date(item.campaignenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                                </template>                    
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="editCampaignDialog(item)"
                                  >
                                    <v-icon>mdi-pencil</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="deleteCampaignDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-contents'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Contents</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="primary"
                                  @click="isAddContent=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="contentpostdate"
                                sort-desc
                                item-key="_id"
                                show-select
                                single-select
                                v-model="selectedContent"
                                :headers="header_contents"
                                :items="campaignid!=null ? data_contents.filter(content=>content.campaignid==campaignid) : data_contents"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeleteContent" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Content? </v-card-title>
                                      <v-card-text>
                                        {{ delete_content.contenttitle }}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteContent = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectContent(delete_content)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.contentimage="{ item }">
                                  <v-img
                                    v-bind:src="item.contentimage"
                                    max-height="60"
                                    max-width="60"
                                  ></v-img>
                                </template>  
                                <template v-slot:item.contenttitle="{ item }">
                                  <p class="two-line"><b>{{item.contentrank}}. {{ item.contenttype }}</b></p>
                                  <p class="two-line">{{ item.contenttitle }}</p>
                                  <p class="two-line"><span style="font-size: 10pt">Post Date: </span>{{ new Date(item.contentpostdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                                  <p class="two-line" v-if="item.isNoStory==true"><span style="font-size: 10pt; font-weight: 700;">No Story</span></p>
                                </template> 
                                <template v-slot:item.contenttext1="{ item }">
                                  <p class="two-line" style="font-size: 10pt;">{{ item.contenttext1.substring(0,50) }}...</p>
                                  <p class="two-line" style="font-size: 10pt;">{{ item.contenttext2.substring(0,50) }}...</p>
                                </template>
                                <template v-slot:item.userid="{ item }">
                                  <div v-if="item.userid!=undefined">
                                    <p class="two-line" style="margin-left: 5px;">
                                  <v-avatar v-if="item.userid!=null && users.length>0" size="30">
                                    <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                                  </v-avatar>
                                  <v-avatar
                                    v-else
                                    color="warning"
                                    size="30">
                                    <p class="two-line"><span class="white--text headline">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                                  </v-avatar>
                                  </p>
                                  <p class="two-line"><span style="margin-left:5px; font-size: 9pt;">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span></p>
                                  </div>
                                </template>     
                                <template v-slot:item.approval="{ item }">
                                  <div v-if="item.approval!=null && item.approval.approverid!=null">
                                    <p class="two-line" style="margin-left: 5px;">
                                      <v-avatar v-if="item.approval.approvalimage!=null" size="30">
                                        <img v-bind:src="item.approval.approvalimage" alt="">
                                      </v-avatar>
                                    </p>
                                  <p class="two-line"><span style="margin-left:5px;font-size: 9pt;">{{ item.approval.approvalname }} </span></p>
                                  </div>
                                </template>
                                <template v-slot:item.contentstatus="{ item }">
                                  <v-chip
                                    v-if="item.contentstatus!=undefined"
                                    :color="getStatusColor(item.contentstatus)" small>
                                    {{ item.contentstatus }}
                                  </v-chip>
                                  <p class="two-line" style="font-size: xx-small;">{{ item.projectnote }}</p>
                                </template>
                                                   
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    v-if="isContentEditable(item.contentstatus)"
                                    icon
                                    color="primary"
                                    @click="editContentDialog(item)"
                                  >
                                    <v-icon>mdi-pencil</v-icon>
                                  </v-btn>
                                  <v-btn v-if="item.contentstatus=='New'" icon color="primary" @click="approveContentDialog(item)">
                                    <v-icon>mdi-account-edit-outline</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="item.contentstatus=='New'"
                                    icon
                                    color="primary"
                                    @click="deleteContentDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                  <v-btn v-if="item.contentstatus=='Approved' || item.contentstatus=='Posted'" icon color="primary" @click="postContentDialog(item)">
                                    <v-icon>mdi-send</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="3"
                      :value="'tab-posts'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Posts</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="primary"
                                  @click="isAddPost=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="postdate"
                                sort-desc
                                item-key="_id"
                                :headers="header_posts"
                                :items="contentid!=null ? posts.filter(content=>content.contentid==contentid) : posts"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeletePost" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Post? </v-card-title>
                                      <v-card-text>
                                        {{ delete_post.posttitle }}
                                      </v-card-text>
                                      <v-card-text>
                                        This action will delete a post on a social media platform. 
                                        <br>Consumers will no longer see the post on the page. 
                                        <br>Please confirm this action prior to deleting.  
                                      </v-card-text>
                                      <v-card-text>
                                        <v-container>
                                          <v-row>
                                            <v-col cols="12" md="12">
                                              <v-text-field
                                                v-model="delete_post.confirm"
                                                required
                                                dense
                                                persistent-hint
                                                single-line hint="Type the word 'Delete'"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeletePost = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          :disabled="delete_post.confirm!=='Delete'"
                                          :loading="isDeleting"
                                          @click="deleteProjectPost(delete_post)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.postdate="{ item }">
                                  {{ new Date(item.postdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}
                                </template>
                                <template v-slot:item.posttype="{ item }">
                                  <p class="two-line">{{item.posttype}}</p>
                                  <p class="two-line">{{item.posttitle}}</p>
                                </template> 
                                <template v-slot:item.post_id="{ item }">
                                  <p v-for="(ad,i) in adsets.filter(ad=>ad.post_id==item.post_id)" :key="i" class="two-line" style="font-size: 9pt;">{{ ad.optimization_goal }} {{ ad.lifetime_budget }}</p>
                                </template>  
                                <template v-slot:item.contentid="{ item }">
                                  <v-img
                                    v-if="item.contentid!=null"
                                    v-bind:src="contents.find(content=>content._id==item.contentid)['contentimage']"
                                    max-height="60"
                                    max-width="60"
                                  ></v-img>
                                </template>    
                                <template v-slot:item.actions="{ item }">
                                  <v-btn icon color="primary" @click="viewPostDialog(item)">
                                    <v-icon>mdi-magnify</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="deletePostDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="4"
                      :value="'tab-comments'"
                    >
                    <v-divider></v-divider>
                    <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Comments</p>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="created_date"
                                sort-desc
                                item-key="comment_id"
                                :headers="header_comments"
                                :items="contentid!=null ? comments.filter(comment=>comment.contentid==contentid) : comments"
                                :items-per-page="50"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeletePost" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Comment? </v-card-title>
                                      <v-card-text>
                                        {{ delete_post.message }}
                                      </v-card-text>
                                      <v-card-text>
                                        This action will delete a post on a social media platform. 
                                        <br>Consumers will no longer see the post on the page. 
                                        <br>Please confirm this action prior to deleting.  
                                      </v-card-text>
                                      <v-card-text>
                                        <v-container>
                                          <v-row>
                                            <v-col cols="12" md="12">
                                              <v-text-field
                                                v-model="delete_post.confirm"
                                                required
                                                dense
                                                persistent-hint
                                                single-line hint="Type the word 'Delete'"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeletePost = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          :disabled="delete_post.confirm!=='Delete'"
                                          :loading="isDeleting"
                                          @click="deleteProjectPost(delete_post)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.contentid="{ item }">
                                  <v-img
                                    v-if="item.contentid!=null"
                                    v-bind:src="contents.find(content=>content._id==item.contentid)['contentimage']"
                                    max-height="40"
                                    max-width="40"
                                  ></v-img>
                                </template>  
                                <template v-slot:item.created_time="{ item }">
                                  <p class="two-line">{{ new Date(item.created_time).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</p>
                                </template>
                                <template v-slot:item.message="{ item }">
                                  <p class="two-line">{{ item.message }}</p>
                                </template>
                                <template v-slot:item.from="{ item }">
                                  <p class="two-line">{{ item.from.name!=null ? item.from.name : '' }}</p>
                                </template>                 
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="deletePostDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="5"
                      :value="'tab-ads'"
                    >
                    <v-divider></v-divider>
                    <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Ad Sets</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="primary"
                                  @click="isAddAd=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="adset_date"
                                sort-desc
                                item-key="_id"
                                :headers="header_ads"
                                :items="adsets"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeleteAd" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Ad? </v-card-title>
                                      <v-card-text>
                                        {{ delete_ad.adset_name }}
                                      </v-card-text>
                                      <v-card-text>
                                        This action will delete this adset.   
                                        <br>Please confirm this action prior to deleting.  
                                      </v-card-text>
                                      <v-card-text>
                                        <v-container>
                                          <v-row>
                                            <v-col cols="12" md="12">
                                              <v-text-field
                                                v-model="delete_ad.confirm"
                                                required
                                                dense
                                                persistent-hint
                                                single-line hint="Type the word 'Delete'"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteAd = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          :disabled="delete_ad.confirm!=='Delete'"
                                          :loading="isDeleting"
                                          @click="deleteProjectAdset(delete_ad)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.start_time="{ item }">
                                  <p class="two-line">{{ new Date(item.start_time).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}<span style="font-size: x-small;">&nbsp;to&nbsp;</span></p>
                                  <p class="two-line">{{ new Date(item.end_time).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</p>
                                </template>
                                <template v-slot:item.adset_name="{ item }">
                                  <p class="two-line">{{ item.adset_name }}</p>
                                  <p class="two-line">Id: {{ item.adset_id }}</p>
                                </template>
                                <template v-slot:item.optimization_goal="{ item }">
                                  <p class="two-line">{{ item.optimization_goal }}</p>
                                  <p class="two-line">{{ item.billing_event }}</p>
                                </template>
                                <template v-slot:item.lifetime_budget="{ item }">
                                  <p class="two-line">{{ item.lifetime_budget.toFixed(2) }}</p>
                                </template>                  
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    v-if="item.adset_id==''"
                                    icon
                                    color="primary"
                                    @click="deleteAdsetDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-dialog
      v-model="isAddCampaign"
      persistent
      width="800px"
      max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Campaign</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="add_campaign.campaignrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="add_campaign.campaignname"
                    label="Name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="campaigntype"
                    v-model="add_campaign.campaigntype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-file-input dense label="File input" v-model="new_campaignphoto" v-on:change="onChangeCampaignPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="['New', 'Active', 'Inactive']"
                    v-model="add_campaign.campaignstatus"
                    placeholder="Status"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="new_campaignstartdate"
                    v-model="new_campaignstartdate"
                    :close-on-content-click="false"
                    :return-value.sync="add_campaign.campaignstartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="add_campaign.campaignstartdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="add_campaign.campaignstartdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        single-line hint="Please choose the start date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_campaign.campaignstartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="new_campaignstartdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.new_campaignstartdate.save(add_campaign.campaignstartdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="new_campaignenddate"
                    v-model="new_campaignenddate"
                    :close-on-content-click="false"
                    :return-value.sync="add_campaign.campaignenddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="add_campaign.campaignenddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="add_campaign.campaignenddate"
                        v-on="on"
                        single-line hint="Please choose the end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_campaign.campaignenddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="new_campaignenddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.new_campaignenddate.save(add_campaign.campaignenddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_campaign.campaigndesc"
                    rows=3
                    label="Description"
                    hint="please enter campaign brief"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddCampaign=false; add_campaign={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addProjectCampaignRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="isEditCampaign"
      persistent
      width="800px"
      max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Campaign</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_campaign.campaignrank"
                    v-on:change="onChangeCampaign($event, 'campaignrank')"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_campaign.campaignname"
                    v-on:change="onChangeCampaign($event, 'campaignname')"
                    label="Name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="campaigntype"
                    v-model="edit_campaign.campaigntype"
                    v-on:change="onChangeCampaign($event, 'campaigntype')"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-file-input dense label="File input" v-model="edit_campaignphoto" v-on:change="onChangeEditCampaignPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="['New', 'Active', 'Inactive']"
                    v-model="edit_campaign.campaignstatus"
                    v-on:change="onChangeCampaign($event, 'campaignstatus')"
                    placeholder="Status"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="edit_campaignstartdate"
                    v-model="edit_campaignstartdate"
                    :close-on-content-click="false"
                    :return-value.sync="edit_campaign.campaignstartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="edit_campaign.campaignstartdate"
                        v-on:change="onChangeCampaign($event, 'campaignstartdate')"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        single-line hint="Please choose the start date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_campaign.campaignstartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="edit_campaignstartdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.edit_campaignstartdate.save(edit_campaign.campaignstartdate); onChangeCampaign(edit_campaign.campaignstartdate, 'campaignstartdate')"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="edit_campaignenddate"
                    v-model="edit_campaignenddate"
                    :close-on-content-click="false"
                    :return-value.sync="edit_campaign.campaignenddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="edit_campaign.campaignenddate"
                        v-on:change="onChangeCampaign($event, 'campaignenddate')"
                        label="End Date"
                        v-bind="attrs"
                        v-on="on"
                        single-line hint="Please choose the end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_campaign.campaignenddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="edit_campaignenddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.edit_campaignenddate.save(edit_campaign.campaignenddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="edit_campaign.campaigndesc"
                    v-on:change="onChangeCampaign($event, 'campaigndesc')"
                    rows=3
                    label="Description"
                    hint="please enter campaign brief"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditCampaign=false; edit_campaign={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editProjectCampaign"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddContent"
        persistent
        width="900px"
        max-width="900px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add Content</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="add_content.contentrank"
                      class="mb-4"
                      placeholder="Num"
                      type="number"
                      oninput="if(this.value < 0) this.value = 0;"
                      single-line
                      hint="Num"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="add_content.contenttitle"
                      label="Title"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-switch
                      dense
                      color="primary"
                      v-model="add_content.isNoStory"
                      v-bind:value="add_content ? add_content.isNoStory : false"
                      hint="No Story"
                      persistent-hint
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      ref="new_contentpostdate"
                      v-model="new_contentpostdate"
                      :close-on-content-click="false"
                      :return-value.sync="add_content.contentpostdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_content.contentpostdate"
                          label="Post Date"
                          v-bind="attrs"
                          v-bind:value="add_content.contentpostdate"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the post date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_content.contentpostdate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_contentpostdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_contentpostdate.save(add_content.contentpostdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_content.campaignid"
                      placeholder="Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['Facebook Post', 'Facebook Video', 'TikTok Post', 'Youtube Post']"
                      v-model="add_content.contenttype"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                      dense
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-file-input dense label="File input" v-model="new_contentphoto" v-on:change="onChangeContentPhoto" accept="image/*" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="add_content.contentlink"
                      label="Link"
                      required
                      dense
                      hint="External File Link"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="add_content.contenttext1"
                      rows=5
                      label="Caption"
                      hint="please enter content caption"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="add_content.contenttext2"
                      rows=5
                      label="Second Caption"
                      hint="please enter secondary caption"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddContent=false; add_content={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addProjectContentRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditContent"
        persistent
        width="900px"
        max-width="900px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Content</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="edit_content.contentrank"
                      v-on:change="onChangeContent($event, 'contentrank')"
                      class="mb-4"
                      placeholder="Num"
                      type="number"
                      oninput="if(this.value < 0) this.value = 0;"
                      single-line
                      hint="Num"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="edit_content.contenttitle"
                      v-on:change="onChangeContent($event, 'contenttitle')"
                      label="Title"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-switch
                      dense
                      color="primary"
                      v-model="edit_content.isNoStory"
                      v-on:change="onChangeContent($event, 'isNoStory')"
                      v-bind:value="edit_content ? edit_content.isNoStory : false"
                      hint="No Story"
                      persistent-hint
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      ref="edit_contentpostdate"
                      v-model="edit_contentpostdate"
                      :close-on-content-click="false"
                      :return-value.sync="edit_content.contentpostdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="edit_content.contentpostdate"
                          v-on:change="onChangeContent($event, 'contentpostdate')"
                          label="Post Date"
                          v-bind="attrs"
                          v-bind:value="edit_content.contentpostdate"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the post date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="edit_content.contentpostdate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="edit_contentpostdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.edit_contentpostdate.save(edit_content.contentpostdate); onChangeContent(edit_content.contentpostdate, 'contentpostdate')"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="edit_content.campaignid"
                      v-on:change="onChangeContent($event, 'campaignid')"
                      placeholder="Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['Facebook Post', 'Facebook Video', 'TikTok Post', 'Youtube Post']"
                      v-model="edit_content.contenttype"
                      v-on:change="onChangeContent($event, 'contenttype')"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-file-input dense label="File input" v-model="edit_contentphoto" v-on:change="onChangeEditContentPhoto" accept="image/*" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="edit_content.contentlink"
                      v-on:change="onChangeContent($event, 'contentlink')"
                      label="Link"
                      required
                      dense
                      hint="External File Link"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select
                      class="mb-4"
                      :items="['New', 'Pending', 'Approved', 'Posted']"
                      v-model="edit_content.contentstatus"
                      v-on:change="onChangeContent($event, 'contentstatus')"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="edit_content.contenttext1"
                      v-on:change="onChangeContent($event, 'contenttext1')"
                      rows=5
                      label="Caption"
                      hint="please enter content caption"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="edit_content.contenttext2"
                      v-on:change="onChangeContent($event, 'contenttext2')"
                      rows=5
                      label="Second Caption"
                      hint="please enter secondary caption"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditContent=false; edit_content={};"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editProjectContent"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddPost"
        persistent
        width="800px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add Manual Post</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_post.campaignid"
                      placeholder="Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4"
                      :items="['Facebook Post']"
                      v-model="add_post.posttype"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_post.posttitle"
                      label="Post Title"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_post.post_id"
                      label="Post Id"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu
                      ref="new_postdate"
                      v-model="new_postdate"
                      :close-on-content-click="false"
                      :return-value.sync="add_post.postdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_post.postdate"
                          label="Post Date"
                          v-bind="attrs"
                          v-bind:value="add_post.postdate"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the post date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_post.postdate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_postdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_postdate.save(add_post.postdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddPost=false; add_post={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addMarketingPostRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddAd"
        persistent
        width="1000px"
        max-width="1000px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add Ad Set</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_ad.mktcampaignid"
                      placeholder="Marketing Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="posts.filter(post=>post.campaignid==add_ad.mktcampaignid).map(x => {return {text: `${x.posttitle} (${formatStdDate(x.postdate)})`, value: x._id};})"
                      v-model="add_ad.postid"
                      placeholder="Post"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="adcampaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_ad.campaignid"
                      placeholder="Ad Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_ad.adset_name"
                      label="Ad Name"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu
                      ref="new_start_time"
                      v-model="new_start_time"
                      :close-on-content-click="false"
                      :return-value.sync="add_ad.start_time"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_ad.start_time"
                          label="Start Date"
                          v-bind="attrs"
                          v-bind:value="add_ad.start_time"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the start date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_ad.start_time"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_start_time = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_start_time.save(add_ad.start_time)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu
                      ref="new_end_time"
                      v-model="new_end_time"
                      :close-on-content-click="false"
                      :return-value.sync="add_ad.end_time"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_ad.end_time"
                          label="End Date"
                          v-bind="attrs"
                          v-bind:value="add_ad.end_time"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the start date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_ad.end_time"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_end_time = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_end_time.save(add_ad.end_time)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['POST_ENGAGEMENT', 'REACH', 'IMPRESSIONS', 'PAGE_LIKES', 'LINK_CLICKS', 'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS']"
                      v-model="add_ad.optimization_goal"
                      v-bind:error="errorindex == 1"
                      placeholder="Optimization Goal"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['POST_ENGAGEMENT', 'IMPRESSIONS']"
                      v-model="add_ad.billing_event"
                      v-bind:error="errorindex == 1"
                      placeholder="Billing Event"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_ad.lifetime_budget"
                      label="Ad Budget"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['MESSAGE_PAGE', 'BOOK_NOW', 'SHOP_NOW']"
                      v-model="add_ad.call_to_action_type"
                      v-bind:error="errorindex == 1"
                      placeholder="Call To Action"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_ad.call_to_action_link"
                      label="Call To Action Link"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-textarea
                      dense
                      v-model="add_ad.targeting"
                      rows=5
                      label="Targeting"
                      hint="please enter tageting"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddAd=false; add_ad={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addMarketingAdRequest"
                :loading="isSubmitting"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isApproveContent"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send Content for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_content.contenttitle }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_content.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveContent=false; approve_content={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_content.confirm!=='Send'"
                @click="approveProjectContentRequest"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isPostContent"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Post Content</span>
            </v-card-title>
            <v-card-text>
              {{ post_content.contenttitle }}
            </v-card-text>
            <v-card-text>
              This action will post to a social media platform. 
              <br>Consumers will see the content on a public page. 
              <br>Check content for errors and correctness prior to posting.  
            </v-card-text>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="post_content.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Post'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isPostContent=false; post_content={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="post_content.confirm!=='Post'"
                @click="postProjectContentRequest"
                :loading="isPosting"
              >
                Post
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isViewPost"
        persistent
        width="550px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">View Post</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <iframe :src="`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F${view_post.pageid}%2Fposts%2F${view_post.postid}%2F&width=500&show_text=true&height=628`" width="500" height="628" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isViewPost=false; view_post={}"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import { getStatusColor } from '@/util/tools';
import { sortDataDsc } from '@/util/tools';

export default {
  name: "Profile",
  props: {
    isTeam: Boolean
  },
  data() {
    return {
      error: undefined,
      errortag: false,
      errortime: false,
      errorindex: undefined,
      isPosting: false,
      isSubmitting: false,
      isDeleting: false,
      
      isAddAd: false,
      isAddContent: false,
      isAddCampaign: false,
      isAddPost: false,
      
      isDeleteCampaign: false,
      isDeleteContent: false,
      isDeletePost: false,
      isDeleteAd: false,

      isEditCampaign: false,
      isEditContent: false,
      isEditPost: false,
      isEditEvent: false,

      isApproveContent: false,
      isPostContent: false,
      isViewPost: false,
      getStatusColor: getStatusColor,
      uploadtype: 'File',
      media_file: null,
      message_file: null,
      userid: null,
      new_campaignphoto: null,
      new_campaignstartdate: null,
      new_campaignenddate: null,
      new_contentphoto: null,
      new_contentpostdate: null,
      new_start_time: null,
      new_end_time: null,
      new_postdate: null,


      edit_campaignphoto: null,
      edit_contentphoto: null,
      edit_campaignpostdate: null,
      edit_contentpostdate: null,
      edit_campaignstartdate: null,
      edit_campaignenddate: null,

      initvalue: {},
      
      approve_content: {},
      post_content: {},
      view_post: {},
      
      delete_campaign: {},
      delete_content: {},
      delete_post: {},
      delete_ad: {},

      add_ad: {},
      add_campaign: {},
      add_content: {},
      add_post: {},
      add_comments: {},

      edit_campaign: {},
      edit_content: {},
      edit_event: {},
      edit_comments: {},
      change_campaign: {},
      change_content: {},
      change_event: {},
      change_comments: {},
      
      selectedCampaign: [],
      selectedContent: [],
      mktprojects: [],
      campaigns: [],
      posts: [],
      adcampaigns: [],
      adsets: [],
      contents: [],
      comments: [],
      users: [],

      campaigntype: ['Social Media', 'Email & SMS'],
      footer: {'items-per-page-options': [50, 500, 1000, 5000]},
      header_campaigns: [
        { text: "Image", value: "campaignimage", width: "10%" }, 
        { text: "Name", value: "campaignname" },
        { text: "Start Date", value: "campaignstartdate", width: "10%" },
        { text: "End Date", value: "campaignenddate", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      header_contents: [
        { text: "Image", value: "contentimage", width: "10%" }, 
        { text: "Title", value: "contenttitle", width: "15%"  },
        { text: "Caption", value: "contenttext1" },
        { text: "Created By", value: "userid", width: "10%"  },
        { text: "Approve By", value: "approval", width: "10%"  },
        { text: "Status", value: "contentstatus", width: "10%"  },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      header_posts: [
        { text: "Image", value: "contentid", width: "5%" },
        { text: "Post Date", value: "postdate", width: "10%" },
        { text: "Post Type", value: "posttype", width: "30%" }, 
        { text: "Ads", value: "post_id", width: "30%" },         
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      header_ads: [
        { text: "Ad Date", value: "start_time", width: "18%" },
        { text: "Name & Id", value: "adset_name", width: "20%" }, 
        { text: "Goal & Event", value: "optimization_goal", width: "15%" },
        { text: "Budget", value: "lifetime_budget", width: "15%" }, 
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      header_comments: [
        { text: "Image", value: "contentid", width: "4%" },
        { text: "Date", value: "created_time", width: "12%" },
        { text: "Message", value: "message" }, 
        { text: "From", value: "from", width: "10%" }, 
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      formatStdDate: formatStdDate,
    };
  },
  computed: {
    ...mapState('Language', ['languages']),
    campaignid () {
      return this.selectedCampaign.length>0 ? this.selectedCampaign[0]._id : null;
    },
    contentid () {
      return this.selectedContent.length>0 ? this.selectedContent[0]._id : null;
    },
    data_contents () {
      if(this.contents.length==0) return [];
      let results = [
        ...this.contents.filter(content=>content.contentstatus=='New'),
        ...this.contents.filter(content=>content.contentstatus=='Pending'),
        ...this.contents.filter(content=>content.contentstatus=='Approved'),
        ...this.contents.filter(content=>content.contentstatus=='Posted'),
      ]
      return results;
    },
    data_campaigns () {
      if(this.campaigns.length==0) return [];
      
      let results = this.campaigns.filter(campaign=>this.campaigntype.indexOf(campaign.campaigntype) > -1);
      return results;
    },
  },
  methods: {
    ...mapActions('MarketAd', ["insertMarketAdsetRequest", "deleteProjectAdsetRequest"]),
    ...mapActions('MarketCampaign', [
      'deleteProjectCampaignRequest', 
      'insertProjectCampaignRequest', 'insertProjectCampaignWithImageRequest', 
      'updateProjectCampaignRequest', 'updateProjectCampaignWithImageRequest']),
    ...mapActions('MarketContent', [
      'deleteProjectContentRequest', 
      'insertProjectContentRequest', 'insertProjectContentWithImageRequest', 
      'updateProjectContentRequest', 'updateProjectContentWithImageRequest', 'updateMarketContentPendingRequest']),
    ...mapActions('MarketPost', ["insertMarketPostRequest", "insertMarketPostManualRequest", "deleteProjectPostRequest"]),

    ...mapActions('MarketProject', ['getCreativeProjects', 
                    'insertProjectMessageRequest', 'insertProjectSystemMessageRequest', 'insertProjectSystemMessageWithFileRequest', 
                    'insertProjectMessageWithFileRequest',
                    'insertProjectMediaRequest', 'insertProjectMediaWithFileRequest','insertProjectTimeRequest',
                    'deleteProjectMessageRequest', 'deleteProjectMediaRequest']),
    ...mapActions('User', ['getUsersAllRequest']),
    checkError(){
      if(!this.add_time.startdate){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_time.starthour){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_time.startminute){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_time.startampm){
        this.errortag = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.add_time.enddate){
        this.errortag = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.add_time.endhour){
        this.errortag = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.add_time.endminute){
        this.errortag = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.add_time.endampm){
        this.errortag = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.add_time.projectprogress){
        this.errortag = true;
        this.errorindex = 8;
        return false;
      }

      this.errorindex = -1;
      return true;
    },
    checkError2(){
      if(this.uploadtype=='File' && this.media_file==null){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(this.uploadtype=='Link' && !this.add_media.medialink){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_media.mediatype){
        this.errortag = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_media.medianame){
        this.errortag = true;
        this.errorindex = 13;
        return false;
      }
      if(this.add_media.mediatype=='Final File' && this.times.length==0){
        this.errortime = true;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(!this.add_message.messagetext){
        this.errortag = true;
        this.errorindex = 21;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    isContentEditable(status){
      let result;
      let isTeam = this.initvalue._isFrom == 'MarketProjectTeamList';
      if(isTeam==true) result = ['New','Pending', 'Approved', 'Posted'].indexOf(status) >= 0;
      else result = ['New'].indexOf(status) >= 0;
      return result;
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'Dashboard' });
    },
    async addProjectCampaignRequest() {
      let result;
      this.isAddCampaign = false;
      this.add_campaign.projectid = this.initvalue._id;
      if(this.add_campaign.imagefile!==null && this.add_campaign.imagefile!==undefined) result = await this.insertProjectCampaignWithImageRequest(this.add_campaign);
      else result = await this.insertProjectCampaignRequest(this.add_campaign);
      this.projectcampaigns.push(result);
      this.add_campaign = {};
      this.new_campaignphoto = null;
    },
    async addProjectContentRequest() {
      let result;
      this.isAddContent = false;
      this.add_content.projectid = this.initvalue._id;
      if(this.add_content.imagefile!==null && this.add_content.imagefile!==undefined) result = await this.insertProjectContentWithImageRequest(this.add_content);
      else result = await this.insertProjectContentRequest(this.add_content);
      this.contents.push(result);
      this.add_content = {};
      this.new_contentphoto = null;
    },
    async addMarketingAdRequest() {
      if(this.isSubmitting==true) return;
      this.isSubmitting= true;
      this.add_ad.projectid = this.initvalue._id;
      let result = await this.insertMarketAdsetRequest(this.add_ad);
      this.adsets.push(result);
      this.isSubmitting = false;
      this.isAddAd = false;
      this.add_ad = {};
    },
    async addMarketingPostRequest() {
      this.add_post.projectid = this.initvalue._id;
      let result = await this.insertMarketPostManualRequest(this.add_post);
      this.posts.push(result);
      this.isAddPost = false;
      this.add_post = {};
    },
    approveContentDialog(item) {
      this.isApproveContent = true;
      this.approve_content = {
        _id: item._id,
        contenttitle: item.contenttitle,
      };
    },
    postContentDialog(item) {
      this.isPostContent = true;
      this.post_content = {
        _id: item._id,
        contenttitle: item.contenttitle,
      };
    },
    async approveProjectContentRequest() {
      this.isApproveContent = false;
      this.approve_content.contentid = this.approve_content._id;
      let result = await this.updateMarketContentPendingRequest(this.approve_content);
      let index = this.contents.findIndex((x) => x._id == result._id);
      this.contents.splice(index, 1, result);
      this.approve_content = {};
    },
    async postProjectContentRequest() {
      if(this.isPosting==true) return;
      this.isPosting= true;
      this.post_content.contentid = this.post_content._id;
      let result = await this.insertMarketPostRequest(this.post_content);
      this.posts.push(result);
      this.isPosting= false;
      this.isPostContent = false;
    },
    deleteCampaignDialog(item) {
      this.isDeleteCampaign = true;
      this.delete_campaign = { _id: item._id, campaignname: item.campaignname };
    },
    deleteContentDialog(item) {
      this.isDeleteContent = true;
      this.delete_content = { _id: item._id, contenttitle: item.contenttitle };
    },
    deletePostDialog(item) {
      this.isDeletePost = true;
      this.delete_post = { _id: item._id, posttitle: item.posttitle };
    },
    deleteAdsetDialog(item) {
      this.isDeleteAd = true;
      this.delete_ad = { _id: item._id, adset_name: item.adset_name };
    },
    async deleteProjectCampaign(payload) {
      this.isDeleteCampaign = false;
      let response = await this.deleteProjectCampaignRequest(payload);
      let index = this.campaigns.findIndex((trans) => trans._id == response._id);
      this.campaigns.splice(index, 1);
    },
    async deleteProjectContent(payload) {
      this.isDeleteContent = false;
      let response = await this.deleteProjectContentRequest(payload);
      let index = this.contents.findIndex((trans) => trans._id == response._id);
      this.contents.splice(index, 1);
    },
    async deleteProjectPost(payload) {
      if(this.isDeleting==true) return;
      this.isDeleting= true;
      let response = await this.deleteProjectPostRequest(payload);
      let index = this.posts.findIndex((trans) => trans._id == response._id);
      this.posts.splice(index, 1);
      this.isDeletePost = false;
      this.isDeleting = false;
    },
    async deleteProjectAdset(payload) {
      this.isDeleteAd = false;
      let response = await this.deleteProjectAdsetRequest(payload);
      let index = this.adsets.findIndex((trans) => trans._id == response._id);
      this.adsets.splice(index, 1);
    },
    async deleteProjectMessage(payload) {
      let response = await this.deleteProjectMessageRequest(payload);
      let index = this.messages.findIndex((trans) => trans._id == response._id);
      this.messages.splice(index, 1);
    },
    editContentDialog(item) {
      this.edit_content = Object.assign({}, item);
      this.change_content = {};
      this.edit_content.contentpostdate = formatStdDate(this.edit_content.contentpostdate);
      this.isEditContent = true;
    },
    editCampaignDialog(item) {
      this.edit_campaign = Object.assign({}, item);
      this.change_campaign = {};
      this.edit_campaign.campaignstartdate = formatStdDate(this.edit_campaign.campaignstartdate);
      this.edit_campaign.campaignenddate = formatStdDate(this.edit_campaign.campaignenddate);
      this.change_campaign = {};
      this.isEditCampaign = true;
    },
    async editProjectCampaign() {
      let response;
      this.isEditCampaign = false;
      this.change_campaign.campaignid = this.edit_campaign._id;
      
      if(this.change_campaign.imagefile!==null && this.change_campaign.imagefile!==undefined) response = await this.updateProjectCampaignWithImageRequest(this.change_campaign);
      else response = await this.updateProjectCampaignRequest(this.change_campaign);
      let index = this.campaigns.findIndex((x) => x._id == response._id);
      this.campaigns.splice(index, 1, response);
      this.edit_campaign = {};
      this.edit_campaignphoto = null;
    },
    async editProjectContent() {
      let response;
      this.isEditContent = false;
      this.change_content.contentid = this.edit_content._id;
      
      if(this.change_content.imagefile!==null && this.change_content.imagefile!==undefined) response = await this.updateProjectContentWithImageRequest(this.change_content);
      else response = await this.updateProjectContentRequest(this.change_content);
      let index = this.contents.findIndex((x) => x._id == response._id);
      this.contents.splice(index, 1, response);
      this.edit_content = {};
      this.edit_contentphoto = null;
    },
    onChangeFile(file) {
      if (!file) this.media_file.file = null;
      else this.media_file = file;
    },
    onChangeMessageFile(file) {
      if (!file) this.message_file.file = null;
      else this.message_file = file;
    },
    onChangeCampaignPhoto(file) {
      if (!file) return;
      this.add_campaign.imagefile = file;
      this.add_campaign.imagename = file.name;
    },
    onChangeEditCampaignPhoto(file) {
      if (!file) return;
      this.change_campaign.imagefile = file;
      this.change_campaign.imagename = file.name;
    },
    onChangeEditContentPhoto(file) {
      if (!file) return;
      this.change_content.imagefile = file;
      this.change_content.imagename = file.name;
    },
    onChangeContentPhoto(file) {
      if (!file) return;
      this.add_content.imagefile = file;
      this.add_content.imagename = file.name;
    },
    onChangeCampaign(value, field){
      this.change_campaign[field] = value;
    },
    onChangeContent(value, field){
      this.change_content[field] = value;
    },
    viewPostDialog(item) {
      this.isViewPost = true;
      this.view_post = {
        _id: item._id,
        posturl: item.posturl,
        pageid: item.post_id.split("_")[0],
        postid: item.post_id.split("_")[1],
      };
    },
    async insertMessage() {
      if(!this.checkError3()) return;
      this.isAddCampaign = false;
      this.add_message.id = this.initvalue._id;
      let result;
      if(this.isSystemEnabled==true){
        if(this.message_file!=null){
          this.add_message.file = this.message_file;
          this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
          result = await this.insertProjectSystemMessageWithFileRequest(this.add_message);
        } 
        else {
          this.add_media.file = null;
          result = await this.insertProjectSystemMessageRequest(this.add_message);
        } 
      }
      else if(this.message_file!=null){
        console.log(this.message_file)
        this.add_message.file = this.message_file;
        this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
        result = await this.insertProjectMessageWithFileRequest(this.add_message);
      } 
      else {
        this.add_media.file = null;
        result = await this.insertProjectMessageRequest(this.add_message);
      } 
      this.messages = [result, ...this.messages];
      this.add_message = {};
      this.message_file = null;

    },
    async insertMedia(){
      if(!this.checkError2()) return;
      this.isAddPost = false;
      this.add_media.id = this.initvalue._id;

      if(this.uploadtype=='File'){
        this.add_media.medialink = null;
        delete this.add_media['medialink'];
        this.add_media.file = this.media_file;
        this.add_media.filename = this.media_file!=null ? this.media_file.name : '';
      }
      else{
        this.add_media.file = null;
        delete this.add_media['file'];
      }
      let media;

      if(this.add_media.file!=undefined && this.add_media.file!=null) media = await this.insertProjectMediaWithFileRequest(this.add_media);
      else media = await this.insertProjectMediaRequest(this.add_media);
      this.medias.push(media);
      this.add_media = {};
      this.media_file = null;
      this.uploadtype = 'File';
    },
  },
  async created() {
    this.userid = localStorage.getItem('userid');
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.replace({ name: "MarketProjectList" });
    this.campaigns = this.initvalue.campaigns;
    this.contents = this.initvalue.contents;
    this.posts = this.initvalue.posts;
    this.adcampaigns = this.initvalue.adcampaigns;
    this.adsets = this.initvalue.adsets;
    this.comments = this.initvalue.comments;
    sortDataDsc(this.adsets, 'start_time');
    sortDataDsc(this.comments, 'created_time');

    console.log(this.isTeam)

    if(this.users.length==0) this.users = await this.getUsersAllRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
